import { Alert, Card, Space, Typography } from 'antd';
import { useEffect, useState } from 'react';
import {
  type InventorizationTechnicalDetails,
  isRemoteReadingMountType,
} from '@/features/inventorization/domain/inventorization-technical';
import {
  photoWizardMountTypeDescription,
  photoWizardMountTypeLabel,
  photoWizardText,
} from '@/features/inventorization/photos/photo-wizard-i18n';
import { remoteReadingMountTypeOptions } from '@/features/inventorization/technical-options';
import { AccessibilityPicker } from '@/routers/inventorization/components/AccessibilityPicker';

export function ContextAccessibilityPicker({
  onSaveTechnical,
  technical,
}: {
  onSaveTechnical: (patch: Partial<InventorizationTechnicalDetails>) => Promise<unknown> | unknown;
  technical: InventorizationTechnicalDetails;
}) {
  const [selectedValues, setSelectedValues] = useState(technical.accessibility ?? []);

  useEffect(() => {
    setSelectedValues(technical.accessibility ?? []);
  }, [technical.accessibility]);

  return (
    <AccessibilityPicker
      onChange={values => {
        setSelectedValues(values);
        void onSaveTechnical({ accessibility: values.length > 0 ? values : null });
      }}
      value={selectedValues}
    />
  );
}

export function MeterMountTypePicker({
  onSaveTechnical,
  technical,
}: {
  onSaveTechnical: (patch: Partial<InventorizationTechnicalDetails>) => Promise<unknown> | unknown;
  technical: InventorizationTechnicalDetails;
}) {
  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      {remoteReadingMountTypeOptions.map(option => {
        const isSelected = technical.mountType === option.value;

        return (
          <Card
            aria-pressed={isSelected}
            hoverable
            key={option.value}
            onClick={() => {
              void onSaveTechnical({ mountType: option.value });
            }}
            onKeyDown={event => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                void onSaveTechnical({ mountType: option.value });
              }
            }}
            role="button"
            size="small"
            style={{
              borderColor: isSelected ? '#1677ff' : undefined,
              cursor: 'pointer',
            }}
            tabIndex={0}
          >
            <Space direction="vertical" size={4}>
              <Typography.Text strong>{photoWizardMountTypeLabel(option.value, option.label)}</Typography.Text>
              <Typography.Text type="secondary">
                {photoWizardMountTypeDescription(option.value, option.description)}
              </Typography.Text>
            </Space>
          </Card>
        );
      })}
      {isRemoteReadingMountType(technical.mountType) ? (
        <Alert
          message={photoWizardText('mountType.moduleRequired', 'Module photos will be required next.')}
          showIcon
          type="info"
        />
      ) : null}
    </Space>
  );
}
